import { LiveTrackContacts } from "@/components/LiveTrack/LiveTrackContacts";

const LiveTrackContactsPage = () => {
  return <LiveTrackContacts />;
};

export default LiveTrackContactsPage;
